<template>
  <div class="order-detail">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="line"></div>
      <div class="page-title">订单详情</div>
      <el-button type="text" @click="goBack" class="back-btn">返回</el-button>
    </div>

    <!-- 订单状态信息 -->
    <!-- 待付款 -->
    <div class="order-status-section" v-if="orderInfo.status == 0 && orderInfo.pay_type != 'offline_pay'">
      <div class="order-status-header">
        <div class="order-status-text">订单已提交成功，请尽快付款！</div>
        <div class="order-number">订单编号：{{ orderInfo.order_sn || '393432361554830' }}</div>
      </div>
      <div class="order-payment-info">
        <div class="payment-status">
          <span class="status-label">待付款</span>
          <span class="countdown">请在 <strong>{{ countdownText }}</strong> 内完成支付</span>
        </div>
        <div class="payment-tips">
          该订单会变为保留15分钟（从下单之日算起）。15分钟之后如未支付付款，系统将自动取消该订单。
        </div>
        <div class="payment-actions">
          <el-button type="text" class="cancel-btn" @click="openCancelOrderDialog(orderInfo)">取消订单</el-button>
          <el-button type="primary" class="pay-btn" @click="handlePay(orderInfo)">付款</el-button>
        </div>
      </div>
    </div>
    <!-- 待付款 -->

    <!-- 待发货 -->
    <div class="order-status-section" v-if="orderInfo.status == 1">
      <div class="order-status-header">
        <!-- <div class="order-status-text">订单已提交成功，请尽快付款！</div> -->
        <div class="order-number">订单编号：{{ orderInfo.order_sn || '' }}</div>
      </div>
      <div class="order-payment-info">
        <div class="payment-status">
          <span class="status-label">待发货</span>
        </div>
        <div class="payment-tips">
          请耐心等待商家发货
        </div>
        <div class="payment-actions">
          <el-button type="primary" class="tixing-btn" @click="handleRemindDelivery(orderInfo)"
            v-if="orderInfo.status == 1 && orderInfo.btn_list.remind_send == '1'">提醒发货</el-button>

          <el-button type="primary" class="tixing-btn" v-if="orderInfo.btn_list.remind_already == '1'"
            disabled>已提醒</el-button>
        </div>
      </div>
    </div>
    <!-- 待发货 -->



    <!-- 待收货 -->
    <div class="order-status-section" v-if="orderInfo.status == 2">
      <div class="order-status-header">
        <!-- <div class="order-status-text">订单已提交成功，请尽快付款！</div> -->
        <div class="order-number">订单编号：{{ orderInfo.order_sn || '' }}</div>
      </div>
      <div class="order-payment-info">
        <div class="payment-status">
          <span class="status-label">待收货</span>
        </div>
        <div class="payment-tips">
          您购买的商品正在配送中，请耐心等待~
        </div>
        <div class="payment-actions">
          <el-button type="text" class="shouhuo-btn" @click="openLogisticsDialog()">查看物流</el-button>
          <el-button type="text" class="shouhuo-btn" @click="confirmReceipt(orderInfo)">确认收货</el-button>

        </div>
      </div>
    </div>
    <!-- 待收货 -->

    <!-- 待评价 -->
    <div class="order-status-section" v-if="orderInfo.status == 4">
      <div class="order-status-header">
        <!-- <div class="order-status-text">订单已提交成功，请尽快付款！</div> -->
        <div class="order-number">订单编号：{{ orderInfo.order_sn || '' }}</div>
      </div>
      <div class="order-payment-info">
        <div class="payment-status">
          <span class="status-label">待评价</span>
        </div>
        <div class="payment-tips">
          订单待评价，您的评价会给其他买家参考～
        </div>
        <div class="payment-actions">
          <el-button type="text" class="shouhuo-btn" @click="handleDeleteOrder(orderInfo)">删除订单</el-button>

        </div>
      </div>
    </div>
    <!-- 待评价 -->


    <!-- 交易完成 -->
    <div class="order-status-section" v-if="orderInfo.status == 3">
      <div class="order-status-header">
        <!-- <div class="order-status-text">订单已提交成功，请尽快付款！</div> -->
        <div class="order-number">订单编号：{{ orderInfo.order_sn || '' }}</div>
      </div>
      <div class="order-payment-info">
        <div class="payment-status">
          <span class="status-label">交易完成</span>
        </div>
        <div class="payment-tips">
          订单已完成，祝您生活愉快～
        </div>
        <div class="payment-actions">
          <el-button type="text" class="pingjia-btn" @click="goPingjia(orderInfo)">评价</el-button>
        </div>
      </div>
    </div>
    <!-- 交易完成 -->


    <!-- 信息区域 -->
    <div class="info-section-container">
      <!-- 收货人信息 -->
      <div class="info-section">
        <div class="section-header">
          <span class="section-icon">|</span>
          <span class="section-title">收货人信息</span>
        </div>
        <div class="section-content">
          <div class="info-item">
            <span class="info-label">收货人：</span>
            <span class="info-value" v-if="orderInfo.order_info">{{ orderInfo.order_info.receiver_name || '' }}（{{
              orderInfo.order_info.sex == 1 ?
                '先生' : '女士'
            }}）</span>
          </div>
          <div class="info-item">
            <span class="info-label">联系电话：</span>
            <span class="info-value" v-if="orderInfo.order_info">{{ orderInfo.order_info.receiver_mobile || '' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">收货地址：</span>
            <span class="info-value" v-if="orderInfo.order_info">{{ orderInfo.order_info.province || '' }}{{
              orderInfo.order_info.city || '' }}{{
                orderInfo.order_info.district || '' }}{{ orderInfo.order_info.receiver_address || '' }}</span>
          </div>
        </div>
      </div>

      <!-- 订单信息 -->
      <div class="info-section">
        <div class="section-header">
          <span class="section-icon">|</span>
          <span class="section-title">订单信息</span>
        </div>
        <div class="section-content">
          <div class="info-item">
            <span class="info-label">订单备注：</span>
            <span class="info-value" v-if="orderInfo.order_info">{{ orderInfo.order_info.remark || '无' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">订单编号：</span>
            <span class="info-value">
              {{ orderInfo.order_sn || '' }}
              <el-button type="text" size="mini" class="copy-btn"
                @click="copyOrderSn(orderInfo.order_sn)">复制</el-button>
            </span>
          </div>
          <div class="info-item">
            <span class="info-label">下单时间：</span>
            <span class="info-value">{{ orderInfo.create_time || '' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 商品信息表格 -->
    <table class="goods-table-container">
      <thead class="table-header">
        <tr>
          <th class="table-title" colspan="2">商品信息</th>
          <th class="table-column">数量</th>
          <th class="table-column">商品操作</th>
          <th class="table-column">金额</th>
          <!-- <th class="table-column">状态</th> -->
          <th class="table-column">交易操作</th>
        </tr>
      </thead>

      <!-- 商品列表 -->
      <tbody class="goods-list">
        <tr class="goods-item" v-for="(item, index) in orderInfo.order_goods_list
          || [{}]" :key="index">
          <td class="goods-info" colspan="2">
            <div class="goods-image">
              <img :src="item.goods_thumb || ''" alt="商品图片">
            </div>

          </td>
          <td class="goods-operation">
            <div class="goods-details">
              <div class="goods-name">{{ item.goods_name || '' }}</div>
              <div class="goods-spec">{{ item.sku_name || '' }}</div>
              <div class="goods-price">¥{{ item.shop_price || '' }}/{{ item.unit || '个' }}</div>
            </div>
          </td>

          <td class="goods-quantity">{{ item.num || '' }}</td>
          <td class="goods-operation">
            <div class="shouhou-btn"
              v-if="item.refund_btn && item.refund_btn.apply_refund == '1' && item.refund_btn.view_refund == 0"
              @click="goShouhou(item)">
              申请售后
            </div>
            <div class="shouhou-btn"
              v-else-if="item.refund_btn && item.refund_btn.view_refund == '1' && item.refund_btn.apply_refund == 1"
              @click="handleShouhouDetail(item)">
              查看售后详情
            </div>
            <div v-else>-</div>
          </td>
          <td class="goods-amount">¥{{ item.goods_money }}</td>
          <!-- <td class="goods-status">{{ item.order_status_text || '待付款' }}</td> -->
          <td class="goods-trade-operation" v-if="orderInfo.status == 0 && orderInfo.pay_type != 'offline_pay'">
            <span class="countdown-text">剩余{{ countdownText }}</span>
            <el-button type="primary" size="mini" class="pay-now-btn" @click="handlePay(orderInfo)">去付款</el-button>
            <el-button type="text" size="mini" class="cancel-order-btn"
              @click="openCancelOrderDialog(orderInfo)">取消订单</el-button>
          </td>

          <td class="goods-trade-operation"
            v-if="orderInfo.status == 4 || orderInfo.status == 5 || orderInfo.status == -2 || orderInfo.status == -1">
            <el-button type="text" size="mini" class="cancel-order-btn"
              @click="handleDeleteOrder(orderInfo)">删除订单</el-button>
          </td>

          <td class="goods-trade-operation" v-if="orderInfo.status == 3">
            <el-button type="text" size="mini" class="pingjia-btn-small" @click="goPingjia(orderInfo)">去评价</el-button>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- 订单金额汇总 -->
    <div class="order-amount-summary">
      <div class="summary-item">
        <span class="summary-label">商品金额：</span>
        <span class="summary-value">¥{{ orderInfo.payable_money || '182.40' }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">优惠券：</span>
        <span class="summary-value">-¥{{ orderInfo.coupon_money || '5.00' }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">运费：</span>
        <span class="summary-value" v-if="orderInfo.order_info.express_price == 0">包邮</span>
        <span class="summary-value" v-else>¥{{ orderInfo.order_info.express_price || '0.00' }}</span>
      </div>
      <div class="summary-item total">
        <span class="summary-label">应付款：</span>
        <span class="summary-value total-price">¥{{ orderInfo.payable_money || '0.00' }}</span>
      </div>
    </div>


    <!-- 取消订单原因弹窗 -->
    <el-dialog title="请选择取消原因" :visible.sync="cancelOrderDialogVisible" width="520px" :close-on-click-modal="false"
      :show-close="true" center>
      <el-radio-group v-model="selectedCancelReason" class="cancel-reason-group">
        <div v-for="reason in cancelReasons" :key="reason.aid" class="reason-item">
          <span class="reason-text">{{ reason.reason }}</span>
          <el-radio :label="reason.aid" class="reason-radio"></el-radio>
        </div>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelOrderDialogVisible = false">暂不取消</el-button>
        <el-button type="primary" style="background-color: #286CED;" @click="confirmCancelOrder">确定取消</el-button>
      </span>
    </el-dialog>


    <el-dialog title="物流信息" :visible.sync="logisticsVisible" width="60%" center>
      <ViewLogistics v-if="orderInfo.aid" :orderId="orderInfo.aid" :isAfter="false" />
    </el-dialog>

  </div>

</template>

<script>
import ViewLogistics from '@/components/ViewLogistics.vue'
export default {
  name: 'OrdersDeatil',
  components: {
    ViewLogistics
  },
  data() {
    return {
      orderInfo: {

      },
      countdownTime: 0, // 倒计时总秒数
      countdownText: '', // 格式化后的倒计时文本
      countdownInterval: null, // 倒计时定时器

      // 取消订单弹窗相关
      cancelOrderDialogVisible: false,
      selectedCancelReason: '',
      currentOrder: null,
      cancelId: '',
      // 取消订单原因列表
      cancelReasons: [],

      logisticsVisible: false
    }
  },
  mounted() {
    this.getOrderDetail()
    this.getCancelOrderReasons()
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  },
  methods: {
    goBack() {
      this.$parent.currentComponent = 'OrdersList'
    },

    // 获取订单取消原因列表
    getCancelOrderReasons() {
      let data = {
        type: '2',
        list_rows: '10'
      }
      this.$api.getCancelOrderReasons(data).then(res => {
        this.cancelReasons = res || [];
        this.selectedCancelReason = res[0].aid || '';
      }).catch(err => {
        this.$message.error(err);
      })
    },

    // 打开物流弹窗
    openLogisticsDialog() {
      this.logisticsVisible = true;
    },

    // 跳转评价页面
    goPingjia(order) {
      this.$router.push({
        path: '/FabuEvaluate',
        query: {
          orderId: order.aid
        }
      })
    },

    // 跳转售后页面
    goShouhou(order) {
      this.$router.push({
        path: '/ShenqingShouhou',
        query: {
          orderId: order.aid
        }
      })
    },

    // 跳转售后详情
    handleShouhouDetail(order) {
      console.log(order);
      this.$parent.currentComponent = 'ShouhouDetail';
      this.$parent.componentParams = { orderId: order.refund_id };
    },


    // 打开取消订单弹窗
    openCancelOrderDialog(order) {
      this.currentOrder = order;
      this.cancelId = order.aid;
      this.cancelOrderDialogVisible = true;
      this.selectedCancelReason = this.cancelReasons[0].aid || '';
      // this.selectedCancelReason = '1'; // 默认选择第一个原因
    },
    // 确认取消订单
    confirmCancelOrder() {
      console.log(this.selectedCancelReason);
      if (!this.currentOrder) return;

      let data = {
        order_id: this.cancelId,
        return_id: this.selectedCancelReason
      };

      this.$api.cancelOrder(data).then(res => {
        this.$message.success('订单取消成功');
        this.cancelOrderDialogVisible = false;
        this.getOrderDetail(); // 重新获取订单详情
      }).catch(err => {
        this.$message.error(err || '取消订单失败');
      });
    },

    // 处理删除订单
    handleDeleteOrder(order) {
      this.$confirm('确定要删除此订单吗？', '删除订单', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteOrder(order.aid);
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },

    // 删除订单
    deleteOrder(orderId) {
      this.$api.deleteOrder({ order_id: orderId }).then(res => {
        this.$message.success('订单删除成功');
        this.goBack(); // 重新获取订单列表
      }).catch(err => {
        this.$message.error(err || '删除订单失败');
      });
    },

    // 复制订单编号
    copyOrderSn(orderSn) {
      if (!orderSn) {
        this.$message.error('订单编号为空');
        return;
      }
      // 创建临时输入框
      const tempInput = document.createElement('input');
      tempInput.value = orderSn;
      document.body.appendChild(tempInput);
      // 选中并复制
      tempInput.select();
      document.execCommand('copy');
      // 移除临时输入框
      document.body.removeChild(tempInput);
      this.$message.success('订单编号复制成功');
    },

    // 去支付
    handlePay(order) {
      this.$router.push({
        name: 'purchase', // 用 name 跳转，而非 path
        params: {
          id: order.goods_id,
          totalPrice: order.payable_money,
          selectedSkus: order.order_goods_list // 直接传对象/数组
        },
        // 如需保留 query 参数，可加 query
        query: { id: order.goods_id }
      });
    },

    // 处理提醒发货
    handleRemindDelivery(order) {
      this.$api.remindDelivery({ order_id: order.aid }).then(res => {
        this.$message.success('提醒发货成功');
        this.getOrderDetail(); // 重新获取订单列表
      }).catch(err => {
        this.$message.error(err || '提醒发货失败');
      });
    },
    // 确认收货
    confirmReceipt(order) {
      this.$confirm('确定要确认收货吗？', '确认收货', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.confirmReceipt({ order_id: order.aid }).then(res => {
          this.$message.success('确认收货成功');
          this.getOrderDetail(); // 重新获取订单列表
        }).catch(err => {
          this.$message.error(err || '确认收货失败');
        });
      }).catch(() => {
        this.$message.info('已取消确认收货');
      });
    },
    // 获取订单详情
    getOrderDetail() {
      // 从父组件获取订单ID
      const orderId = this.$parent.componentParams ? this.$parent.componentParams.orderId : '';
      if (!orderId) {
        this.$message.error('获取订单ID失败');
        return;
      }
      // 调用API获取订单详情
      this.$api.getOrderDetail({ order_id: orderId, order_type: 3 }).then(res => {
        this.orderInfo = res;
        if (this.orderInfo.status == 0 && this.orderInfo.pay_type != 'offline_pay') {
          this.initCountdown();
        }
        // 初始化倒计时
      }).catch(err => {
        this.$message.error(err || '获取订单详情失败');
        // 如果API调用失败，使用模拟数据初始化倒计时
        // this.initCountdown();
      });
    },
    // 初始化倒计时
    initCountdown() {
      // 假设orderInfo.last_time返回的是剩余时间（秒）
      // 如果接口返回的是其他格式（如时间戳），需要根据实际情况调整
      if (this.orderInfo.last_time) {
        // 这里假设last_time是秒数，根据实际接口返回格式调整
        this.countdownTime = parseInt(this.orderInfo.last_time);
      } else {
        // 使用模拟数据，假设还有1天12小时30分钟（120600秒）
        // this.countdownTime = 1 * 24 * 60 * 60 + 12 * 60 * 60 + 30 * 60;
      }

      // 更新倒计时文本
      this.updateCountdownText();

      // 清除之前的定时器
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }

      // 启动倒计时定时器，每秒更新一次
      this.countdownInterval = setInterval(() => {
        this.countdown();
      }, 1000);
    },
    // 倒计时逻辑
    countdown() {
      if (this.countdownTime > 0) {
        this.countdownTime--;
        this.updateCountdownText();
      } else {
        // 倒计时结束，清除定时器
        if (this.countdownInterval) {
          clearInterval(this.countdownInterval);
          this.countdownInterval = null;
        }
        // 可以在这里添加倒计时结束的处理逻辑
        this.countdownText = '00:00:00';
        this.$message.warning('订单已超时，请重新下单');
      }
    },
    // 格式化倒计时文本
    updateCountdownText() {
      const days = Math.floor(this.countdownTime / (24 * 60 * 60));
      const hours = Math.floor((this.countdownTime % (24 * 60 * 60)) / (60 * 60));
      const minutes = Math.floor((this.countdownTime % (60 * 60)) / 60);
      const seconds = this.countdownTime % 60;

      if (days > 0) {
        // 有天数时显示格式：x天hh:mm:ss
        this.countdownText = `${days}天${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(seconds)}`;
      } else {
        // 无天数时显示格式：hh:mm:ss
        this.countdownText = `${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(seconds)}`;
      }
    },
    // 补零函数，确保数字为两位数
    padZero(num) {
      return num < 10 ? `0${num}` : num;
    }
  }
}
</script>

<style scoped>
.order-detail {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  font-size: 14px;
  color: #333;
}

/* 页面标题 */
.page-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
  padding-left: 10px;
}

.line {
  width: 4px;
  height: 18px;
  background-color: #286CED;
}

.back-btn {
  margin-left: auto;
  color: #286CED;
}

/* 订单状态区域 */
.order-status-section {
  /* border: 1px solid #e8e8e8; */
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  /* background-color: #fafafa; */
}

.order-status-header {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.order-status-text {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 5px;
}

.order-number {
  font-size: 12px;
  color: #666;
}

.order-payment-info {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 15px;
  border-radius: 4px;
  /* border: 1px solid #f0f0f0; */
}

.payment-status {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.status-label {
  font-weight: bold;
  font-size: 16px !important;
  color: #286CED;
  font-size: 12px;
  margin-right: 15px;
}

.countdown {
  color: #666;
  font-size: 12px;
}

.countdown strong {
  color: #ff4d4f;
}

.payment-tips {
  display: flex;
  color: #999;
  font-size: 12px;
  line-height: 1.5;
  margin-bottom: 15px;
}

.payment-actions {
  display: flex;
  justify-content: flex-end;
}

.cancel-btn {
  color: #666;
  margin-right: 10px;
}

.shouhuo-btn {
  background: #F3F3F3;
  padding: 9px 27px;
  color: #333333;
}

.pingjia-btn {
  background-color: #286CED;
  padding: 8px 40px;
  color: #fff;
}

.pingjia-btn-small {
  background-color: #286CED;
  padding: 4px 11px;
  color: #fff;
}

.pay-btn {
  background-color: #286CED;
  border-color: #286CED;
}

.tixing-btn {
  background-color: #fff;
  border-color: #286CED;
  border: 1px solid #286CED;
  color: #286CED;
}

/* 信息区域容器 */
.info-section-container {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.info-section {
  flex: 1;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
}

.section-header {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e8e8e8;
}

.section-icon {
  color: #286CED;
  font-weight: bold;
  margin-right: 5px;
}

.section-title {
  font-weight: 500;
  color: #333;
}

.section-content {
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: start;
}

.info-item {
  margin-bottom: 10px;
  line-height: 1.5;
}

.info-label {
  color: #666;
  margin-right: 5px;
}

.info-value {
  color: #333;
}

.copy-btn {
  padding: 0;
  font-size: 12px;
  color: #286CED;
  margin-left: 10px;
}

/* 商品信息表格 */
.goods-table-container {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
}

.table-header {
  background-color: #f5f7fa;
}

.table-header th {
  padding: 12px;
  text-align: center;
  font-weight: 500;
  color: #333;
  border-bottom: 1px solid #e8e8e8;
}

.table-title {
  text-align: center;
}

.table-column {
  width: 14.28%;
  /* 7列，每列平均分配宽度 */
}

/* 商品列表 */
.goods-list {
  background-color: #fff;
}

/* 商品项 */
.goods-item td {
  padding: 15px;
  border-bottom: 1px solid #f0f0f0;
  text-align: center;
}

.goods-item:last-child td {
  border-bottom: none;
}

.goods-info {
  display: flex;
  align-items: center;
  text-align: left;
}

.goods-image {
  width: 80px;
  height: 80px;
  border: 1px solid #e8e8e8;
  margin-right: 15px;
  overflow: hidden;
}

.goods-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.goods-details {
  flex: 1;
}

.goods-name {
  color: #333;
  margin-bottom: 5px;
  line-height: 1.4;
}

.goods-spec {
  color: #999;
  font-size: 12px;
  margin-bottom: 5px;
}

.goods-price {
  color: #333;
  font-size: 14px;
}

/* 移除固定宽度设置，改为均匀分布 */
.goods-quantity,
.goods-operation,
.goods-amount,
.goods-status {
  width: auto;
  text-align: center;
  color: #333;
  margin: 0;
}

.goods-trade-operation {
  text-align: center;
  margin: 0;
}

.countdown-text {
  display: block;
  color: #ff4d4f;
  font-size: 12px;
  margin-bottom: 5px;
}

.pay-now-btn {
  background-color: #286CED;
  border-color: #286CED;
  margin-bottom: 5px;
  padding: 4px 8px;
  font-size: 12px;
}

.cancel-order-btn {
  padding: 4px 8px;
  font-size: 12px;
  color: #666;
}

/* 订单金额汇总 */
.order-amount-summary {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 15px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  background-color: #fafafa;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  width: 300px;
  margin-bottom: 10px;
  font-size: 14px;
}

.summary-label {
  color: #666;
}

.summary-value {
  color: #333;
}

.summary-item.total {
  font-weight: 500;
  padding-top: 10px;
  border-top: 1px solid #e8e8e8;
  margin-top: 5px;
}

.total-price {
  color: #ff4d4f;
  font-size: 16px;
}

/* 取消订单弹窗样式 */
.cancel-reason-group {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 20px;
}

.reason-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #333;
  padding: 5px 0;
}

.reason-text {
  text-align: left;
}

.reason-radio {
  text-align: right;
}

/* 隐藏radio组件的默认文本 */
::v-deep .reason-radio .el-radio__label {
  display: none;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.shouhou-btn {
  font-size: 14px;
  color: #286CED;
}
</style>